import type { SVGProps } from 'react';

const SvgBookmarkFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M17.4443 2C18.8211 2 20 3.08532 20 4.5V21C20 21.3658 19.8005 21.7026 19.4795 21.8779C19.1584 22.0532 18.7667 22.0386 18.459 21.8408L12 17.6885L5.54102 21.8408C5.23331 22.0386 4.84158 22.0532 4.52051 21.8779C4.19952 21.7026 4 21.3658 4 21V4.5C4 3.08532 5.17886 2 6.55566 2H17.4443Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgBookmarkFilled;
